export const DASHBOARD_ROUTE = '/reports';
